import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Marketplace from "@/pages/Marketplace";
import CourseDetail from "@/pages/CourseDetail";
import CoursePlayer from "@/pages/CoursePlayer";
import CourseBuilder from "@/pages/CourseBuilder";
import MyLearning from "@/pages/MyLearning";
import MyCourses from "@/pages/MyCourses";
import Certificates from "@/pages/Certificates";
import Organization from "@/pages/Organization";
import Licenses from "@/pages/Licenses";
import JoinByCode from "@/pages/JoinByCode";
import CompanyAnalytics from "@/pages/CompanyAnalytics";
import CreatorAnalytics from "@/pages/CreatorAnalytics";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="font-serif text-3xl">Forge<span className="text-[#E63946]">.</span></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Auth callback: synchronously detect session_id in URL hash (before useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/marketplace" element={<Protected><Marketplace /></Protected>} />
      <Route path="/join/:code" element={<JoinByCode />} />
      <Route path="/licenses" element={<Protected><Licenses /></Protected>} />
      <Route path="/analytics" element={<Protected><CompanyAnalytics /></Protected>} />
      <Route path="/creator-analytics" element={<Protected><CreatorAnalytics /></Protected>} />
      <Route path="/courses" element={<Protected><MyCourses /></Protected>} />
      <Route path="/courses/:id" element={<Protected><CourseDetail /></Protected>} />
      <Route path="/learn/:id" element={<Protected><CoursePlayer /></Protected>} />
      <Route path="/learning" element={<Protected><MyLearning /></Protected>} />
      <Route path="/builder" element={<Protected><MyCourses /></Protected>} />
      <Route path="/builder/:id" element={<Protected><CourseBuilder /></Protected>} />
      <Route path="/certificates" element={<Protected><Certificates /></Protected>} />
      <Route path="/organization" element={<Protected><Organization /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
